import React, { Component } from "react";
import "./Sidenavbar.css";
import { withStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
// import comment from "../images/transparent_icons/comment.svg";
import logo from "../images/Logo3.PNG";

const useStyles = (theme) => ({
  text: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
      color: "red",
    },
  },
  img: {
    width: "20px",
    height: "30px",
    fontColor: "white",
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
      marginLeft: "0.9rem",
      marginRight: "1.5rem",
      fontColor: "pink",
    },
  },
});
class Sidenavbar extends Component {
  constructor() {
    super();
    this.state = {
      accounts1: {},
      comment1: {},
      employee1: {},
      jobsite1: {},
      order1: {},
      quote1: {},
      position1: "",
    };
  }

  render() {
    const { classes } = this.props;

    return (
      <div
        className="sidenav "
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "260px",
          background: "linear-gradient(180deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)",
          borderRight: "none",
          padding: "20px 16px"
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
          <img src={logo} alt="Rock Pros" style={{ width: 180, height: 'auto' }} />
        </div>
        <NavLink
          end
          className="main-nav"
          to="/"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-th-large" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Dashboard</span>
        </NavLink>
        <NavLink
          className="main-nav"
          to="/viewtruck"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-truck" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Truck</span>
        </NavLink>

        <NavLink
          className="main-nav"
          to="/viewdriver"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-user-friends" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Driver</span>
        </NavLink>
        {/* <NavLink
          className="main-nav"
          to="/truck_Availability"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-clipboard-list" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Truck Availability</span>
        </NavLink> */}

        <NavLink
          className="main-nav"
          to="/dispatcher"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-route" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Dispatch</span>
        </NavLink>
        <NavLink
          className="main-nav"
          to="/all-orders-map"
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            textDecoration: 'none',
            color: '#ffffff',
            padding: '10px 12px',
            borderRadius: '12px',
            background: isActive ? 'rgba(255,255,255,0.16)' : 'transparent',
            border: isActive ? '1px solid rgba(255,255,255,0.28)' : '1px solid transparent',
            marginBottom: 10,
            boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none'
          })}
        >
          <i className="fas fa-map-marked-alt" style={{ fontSize: "18px", marginRight: "12px", width: "20px", textAlign: "center", color: "#ffffff" }}></i>
          <span className={classes.text} style={{ fontSize: "16px", fontWeight: 700, color: '#ffffff' }}>Live Tracking Map</span>
        </NavLink>
        {/* <NavLink
          className="main-nav"
          activeClassName="main-nav-active"
          to="/viewcomplain"
        >
          <span
            style={{
              fontColor: "white",
              fontSize: "18px",
            }}
          >
            <img src={comment} alt="comment" className={classes.img} />{" "}
            <span
              style={{ fontColor: "white", fontSize: "16px" }}
              className={classes.text}
            >
              Comments
            </span>
          </span>
        </NavLink> */}
      </div>
    );
  }
}

export default withStyles(useStyles)(Sidenavbar);
